// material ui
import { Theme } from '@mui/material';

export const tooltipCustomization = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme }: { theme: Theme }) => ({
        backgroundColor:
          theme.palette.mode === 'light'
            ? theme.palette.grey[600]
            : theme.palette.grey[900],
        fontSize: 14,
      }),
    },
  },
};
